import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ElectronicSignature\GetOngoingElectronicSignature::__invoke
* @see app/Http/Controllers/ElectronicSignature/GetOngoingElectronicSignature.php
* @route '/api/electronic-signature/{electronicSignature}/get-ongoing-electronic-signature'
*/
const GetOngoingElectronicSignature = (args: { electronicSignature: string | number | { id: string | number } } | [electronicSignature: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetOngoingElectronicSignature.url(args, options),
    method: 'get',
})

GetOngoingElectronicSignature.definition = {
    methods: ["get","head"],
    url: '/api/electronic-signature/{electronicSignature}/get-ongoing-electronic-signature',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ElectronicSignature\GetOngoingElectronicSignature::__invoke
* @see app/Http/Controllers/ElectronicSignature/GetOngoingElectronicSignature.php
* @route '/api/electronic-signature/{electronicSignature}/get-ongoing-electronic-signature'
*/
GetOngoingElectronicSignature.url = (args: { electronicSignature: string | number | { id: string | number } } | [electronicSignature: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { electronicSignature: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { electronicSignature: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            electronicSignature: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        electronicSignature: typeof args.electronicSignature === 'object'
        ? args.electronicSignature.id
        : args.electronicSignature,
    }

    return GetOngoingElectronicSignature.definition.url
            .replace('{electronicSignature}', parsedArgs.electronicSignature.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ElectronicSignature\GetOngoingElectronicSignature::__invoke
* @see app/Http/Controllers/ElectronicSignature/GetOngoingElectronicSignature.php
* @route '/api/electronic-signature/{electronicSignature}/get-ongoing-electronic-signature'
*/
GetOngoingElectronicSignature.get = (args: { electronicSignature: string | number | { id: string | number } } | [electronicSignature: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetOngoingElectronicSignature.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ElectronicSignature\GetOngoingElectronicSignature::__invoke
* @see app/Http/Controllers/ElectronicSignature/GetOngoingElectronicSignature.php
* @route '/api/electronic-signature/{electronicSignature}/get-ongoing-electronic-signature'
*/
GetOngoingElectronicSignature.head = (args: { electronicSignature: string | number | { id: string | number } } | [electronicSignature: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetOngoingElectronicSignature.url(args, options),
    method: 'head',
})

export default GetOngoingElectronicSignature